import { useState, useEffect } from 'react';
import { getContracts, createContract, updateContract, deleteContract, toggleContractStatus, sendContractReminder, addContractPayment, getDailyContractPayments } from '../../api/contracts.api';
import type { Contract, ContractPaymentDto, DailyPaymentSummary } from '../../api/contracts.api';

// Interface Vehiculo removed


// Interface Contrato removed as we use Contract from API

// Removed interface FormData since we will adapt to API DTO directly
// ... or reused DTO structure.

import { useAuth } from '../../context/AuthContext';
import PremiumLock from '../../components/common/PremiumLock';
import { formatCOP, CurrencyInput } from '../../utils/currencyFormat';

export default function Contratos() {
  const { user } = useAuth();

  // Bloqueo Premium para modo Demo
  if (user?.company?.status === 'PRUEBA') {
    return <PremiumLock feature="contratos" />;
  }

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filterType, setFilterType] = useState('TODOS'); // TODOS, INDIVIDUAL, EMPRESARIAL
  const [filterStatus, setFilterStatus] = useState('TODOS'); // TODOS, ACTIVO, VENCIDO, POR_VENCER
  const [editingId, setEditingId] = useState<string | null>(null);

  // Estados para Cobros
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedContract, setSelectedContract] = useState<Contract | null>(null);
  const [paymentData, setPaymentData] = useState<ContractPaymentDto>({
    monto: 0,
    metodoPago: 'EFECTIVO',
    meses: 1,
    observaciones: ''
  });

  // Estados para Reporte
  const [showReportModal, setShowReportModal] = useState(false);
  const [dailyReport, setDailyReport] = useState<DailyPaymentSummary | null>(null);
  const [reportLoading, setReportLoading] = useState(false);

  // Vehiculos temporales para el formulario
  const [vehiculos, setVehiculos] = useState<any[]>([]);
  const [vehiculoTemp, setVehiculoTemp] = useState({
    placa: '',
    tipo: 'AUTO',
    marca: '',
    modelo: '',
    color: ''
  });

  const [formData, setFormData] = useState({
    tipoContrato: 'INDIVIDUAL' as 'INDIVIDUAL' | 'EMPRESARIAL',
    cliente: '',
    empresa: '',
    nit: '',
    documento: '',
    telefono: '',
    email: '',
    direccion: '',
    plan: 'MENSUAL',
    valorMensual: 0,
    fechaInicio: new Date().toISOString().split('T')[0],
    renovacionAutomatica: true,
    observaciones: ''
  });

  const [contratos, setContratos] = useState<Contract[]>([]);

  useEffect(() => {
    loadContracts();
  }, []);

  const loadContracts = async () => {
    setIsLoading(true);
    try {
      const data = await getContracts();
      setContratos(data);
    } catch (error) {
      console.error('Error loading contracts:', error);
      alert('Error al cargar contratos');
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;

    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      // Campos que deben estar en mayúsculas
      const uppercaseFields = ['cliente', 'empresa', 'documento', 'nit', 'direccion'];
      const finalValue = uppercaseFields.includes(name) ? value.toUpperCase() : value;

      // Si se cambia el tipo de contrato, limpiar campos específicos
      if (name === 'tipoContrato') {
        if (value === 'INDIVIDUAL') {
          setFormData(prev => ({ ...prev, [name]: value, empresa: '', nit: '' }));
        } else if (value === 'EMPRESARIAL') {
          setFormData(prev => ({ ...prev, [name]: value, documento: '' }));
        }
      } else {
        setFormData(prev => ({ ...prev, [name]: finalValue }));
      }
    }
  };

  const handleVehiculoChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setVehiculoTemp(prev => ({
      ...prev,
      [name]: name === 'placa' || name === 'marca' || name === 'modelo' || name === 'color'
        ? value.toUpperCase()
        : value
    }));
  };

  const agregarVehiculo = () => {
    if (!vehiculoTemp.placa || !vehiculoTemp.marca) {
      alert('Por favor complete al menos la placa y marca del vehículo');
      return;
    }

    setVehiculos([...vehiculos, vehiculoTemp]);
    setVehiculoTemp({
      placa: '',
      tipo: 'AUTO',
      marca: '',
      modelo: '',
      color: ''
    });
  };

  const eliminarVehiculo = (index: number) => {
    setVehiculos(vehiculos.filter((_, i) => i !== index));
  };

  // calcularFechaFin removed as logic is handled by backend or not needed for simple validitation


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Si hay un vehículo temporal con datos, agregarlo automáticamente
    let vehiculosParaEnviar = [...vehiculos];
    if (vehiculoTemp.placa && vehiculoTemp.marca) {
      vehiculosParaEnviar.push(vehiculoTemp);
    }

    if (vehiculosParaEnviar.length === 0) {
      alert('Debe agregar al menos un vehículo al contrato');
      return;
    }

    if (!formData.valorMensual || formData.valorMensual <= 0) {
      alert('El valor mensual debe ser mayor a $0');
      return;
    }

    setIsSubmitting(true);
    try {
        const payload = {
            tipoContrato: formData.tipoContrato,
            cliente: formData.cliente,
            empresa: formData.tipoContrato === 'EMPRESARIAL' ? formData.empresa : undefined,
            documento: formData.tipoContrato === 'EMPRESARIAL' ? formData.nit : formData.documento,
            telefono: formData.telefono,
            email: formData.email,
            direccion: formData.direccion,
            plan: formData.plan,
            valorMensual: formData.valorMensual,
            fechaInicio: formData.fechaInicio,
            renovacionAutomatica: formData.renovacionAutomatica,
            observaciones: formData.observaciones,
            vehiculos: vehiculosParaEnviar
        };

        if (editingId) {
            await updateContract(editingId, payload);
        } else {
            await createContract(payload);
        }

      await loadContracts();
      resetForm();
      setShowModal(false);

    } catch (error) {
      console.error('Error saving contract:', error);
      alert('Error al guardar el contrato');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
      setFormData({
        tipoContrato: 'INDIVIDUAL',
        cliente: '',
        empresa: '',
        nit: '',
        documento: '',
        telefono: '',
        email: '',
        direccion: '',
        plan: 'MENSUAL',
        valorMensual: 0,
        fechaInicio: new Date().toISOString().split('T')[0],
        renovacionAutomatica: true,
        observaciones: ''
      });
      setVehiculos([]);
      setEditingId(null);
  };

  const handleEdit = (contrato: Contract) => {
      setEditingId(contrato.id);
      setFormData({
          tipoContrato: contrato.tipoContrato,
          cliente: contrato.cliente,
          empresa: contrato.empresa || '',
          nit: (contrato.tipoContrato === 'EMPRESARIAL' ? contrato.documento : '') || '',
          documento: (contrato.tipoContrato === 'INDIVIDUAL' ? contrato.documento : '') || '',
          telefono: contrato.telefono || '',
          email: contrato.email || '',
          direccion: contrato.direccion || '',
          plan: contrato.plan,
          valorMensual: Number(contrato.valorMensual),
          fechaInicio: contrato.fechaInicio.split('T')[0],
          renovacionAutomatica: contrato.renovacionAutomatica,
          observaciones: contrato.observaciones || ''
      });

      // Map contractVehicles to form format
      if (contrato.contractVehicles) {
          setVehiculos(contrato.contractVehicles.map(cv => ({
              placa: cv.vehiculo.placa,
              tipo: cv.vehiculo.tipo,
              marca: cv.vehiculo.marca,
              modelo: cv.vehiculo.modelo || '',
              color: cv.vehiculo.color || ''
          })));
      } else {
          setVehiculos([]);
      }

      setShowModal(true);
  };

  const handleDelete = async (id: string) => {
      if (!confirm('¿Está seguro de eliminar este contrato? Esta acción no se puede deshacer.')) return;

      setIsLoading(true); // Bloquear UI localmente o usar estado temporal
      try {
          await deleteContract(id);
          await loadContracts();
      } catch (error) {
          console.error('Error deleting contract:', error);
          alert('Error al eliminar el contrato');
          setIsLoading(false);
      }
  };

  const handleToggleStatus = async (id: string) => {
    setIsLoading(true);
    try {
        await toggleContractStatus(id);
        await loadContracts();
    } catch (error) {
        console.error('Error toggling status:', error);
        alert('Error al cambiar el estado del contrato');
    } finally {
        setIsLoading(false);
    }
  };

  const handleSendReminder = async (id: string, email: string | undefined) => {
      if (!email) {
          alert('El contrato no tiene email asociado.');
          return;
      }
      if (!confirm(`¿Enviar recordatorio a ${email}?`)) return;

      setIsLoading(true);
      try {
          await sendContractReminder(id);
          alert('Recordatorio enviado correctamente');
      } catch (error) {
          console.error('Error sending reminder:', error);
          alert('Error al enviar recordatorio');
      } finally {
          setIsLoading(false);
      }
  };

  const handleOpenNew = () => {
      resetForm();
      setShowModal(true);
  };

  const handleOpenPayment = (contrato: Contract) => {
    setSelectedContract(contrato);
    const multiplier = contrato.plan === 'TRIMESTRAL' ? 3 : contrato.plan === 'SEMESTRAL' ? 6 : contrato.plan === 'ANUAL' ? 12 : 1;
    setPaymentData({
      monto: contrato.valorMensual * multiplier,
      metodoPago: 'EFECTIVO',
      meses: 1,
      observaciones: ''
    });
    setShowPaymentModal(true);
  };

  const handlePaymentSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedContract) return;
    if (paymentData.monto <= 0) {
      alert('El monto debe ser mayor a 0');
      return;
    }
    if (!paymentData.meses || paymentData.meses < 1) {
      alert('Debe pagar al menos 1 periodo');
      return;
    }

    setIsSubmitting(true);
    try {
      await addContractPayment(selectedContract.id, paymentData);
      alert('Pago registrado correctamente');
      setShowPaymentModal(false);
      await loadContracts();
    } catch (error) {
      console.error('Error registering payment:', error);
      alert('Error al registrar el pago');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenReport = async () => {
    setShowReportModal(true);
    setReportLoading(true);
    try {
      const data = await getDailyContractPayments();
      setDailyReport(data);
    } catch (error) {
      console.error('Error loading report:', error);
      alert('Error al cargar el reporte');
    } finally {
      setReportLoading(false);
    }
  };

  const filteredContratos = contratos.filter(c => {
    let matchStatus = true;
    if (filterStatus === 'TODOS') {
        matchStatus = true;
    } else if (filterStatus === 'POR_VENCER') {
        const daysToExpiry = Math.ceil((new Date(c.fechaFin).getTime() - new Date().getTime()) / (1000 * 3600 * 24));
        matchStatus = c.status === 'ACTIVO' && daysToExpiry <= 5 && daysToExpiry >= 0;
    } else {
        matchStatus = c.status === filterStatus;
    }

    const matchType = filterType === 'TODOS' || c.tipoContrato === filterType;
    return matchStatus && matchType;
  });

  const contratosIndividuales = contratos.filter(c => c.tipoContrato === 'INDIVIDUAL').length;
  const contratosEmpresariales = contratos.filter(c => c.tipoContrato === 'EMPRESARIAL').length;

  return (
    <>
      <div className="p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <div>
            <h1 className="text-2xl font-bold text-slate-800">Contratos</h1>
            <p className="text-slate-500 text-sm mt-1">Gestión de contratos individuales y empresariales</p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <button
              onClick={handleOpenReport}
              className="bg-slate-100 hover:bg-slate-200 text-slate-700 px-4 py-2.5 rounded-xl flex items-center gap-2 transition whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <i className="ri-history-line text-lg"></i>
              Reporte de Cobros
            </button>
            <button
              onClick={handleOpenNew}
              className="bg-teal-500 hover:bg-teal-600 text-white px-4 py-2.5 rounded-xl flex items-center gap-2 transition whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <i className="ri-file-add-line text-lg"></i>
              Nuevo Contrato
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6">
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm">Total Contratos</p>
                <p className="text-2xl sm:text-3xl font-bold text-slate-800 mt-2">{contratos.length}</p>
              </div>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-file-text-line text-xl sm:text-2xl text-teal-600"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm">Individuales</p>
                <p className="text-2xl sm:text-3xl font-bold text-slate-800 mt-2">{contratosIndividuales}</p>
              </div>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                <i className="ri-user-line text-xl sm:text-2xl text-blue-600"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm">Empresariales</p>
                <p className="text-2xl sm:text-3xl font-bold text-slate-800 mt-2">{contratosEmpresariales}</p>
              </div>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                <i className="ri-building-line text-xl sm:text-2xl text-purple-600"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm">Activos</p>
                <p className="text-2xl sm:text-3xl font-bold text-slate-800 mt-2">{contratos.filter(c => c.status === 'ACTIVO').length}</p>
              </div>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-xl flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-xl sm:text-2xl text-green-600"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6">
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-6 sm:col-span-2 lg:col-span-1">
            <div className="flex items-center justify-between gap-3">
              <div className="flex-1 min-w-0">
                <p className="text-slate-500 text-sm mb-1">Ingresos Mensuales</p>
                <p className="text-2xl sm:text-3xl font-bold text-slate-800">{formatCOP(contratos.filter(c => c.status === 'ACTIVO').reduce((acc, c) => acc + c.valorMensual, 0))}</p>
              </div>
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-xl sm:text-2xl text-orange-600"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-6">
            <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto overflow-x-auto pb-2 sm:pb-0">
              <div className="flex gap-2 border-b sm:border-r sm:border-b-0 border-slate-200 pb-2 sm:pb-0 sm:pr-4">
                {['TODOS', 'ACTIVO', 'VENCIDO', 'POR_VENCER', 'CANCELADO'].map(status => (
                  <button
                    key={status}
                    onClick={() => setFilterStatus(status)}
                    className={`px-3 sm:px-4 py-2 rounded-xl text-xs sm:text-sm font-medium transition whitespace-nowrap cursor-pointer ${
                      filterStatus === status
                        ? 'bg-teal-500 text-white'
                        : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                    }`}
                  >
                    {status === 'TODOS' ? 'Todos los estados' : status === 'POR_VENCER' ? 'Por Vencer' : status}
                  </button>
                ))}
              </div>
              <div className="flex gap-2">
                {['TODOS', 'INDIVIDUAL', 'EMPRESARIAL'].map(type => (
                  <button
                    key={type}
                    onClick={() => setFilterType(type)}
                    className={`px-3 sm:px-4 py-2 rounded-xl text-xs sm:text-sm font-medium transition whitespace-nowrap cursor-pointer ${
                      filterType === type
                        ? 'bg-purple-500 text-white'
                        : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                    }`}
                  >
                    {type === 'TODOS' ? 'Todos los tipos' : type}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-slate-200">
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Tipo</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Cliente/Empresa</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Vehículos</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Plan</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Valor Mensual</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Vigencia</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Periodos</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Estado</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Renovación</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-slate-600">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={10} className="py-8 text-center text-slate-500">
                      <i className="ri-loader-4-line text-2xl animate-spin mb-2 block"></i>
                      Cargando contratos...
                    </td>
                  </tr>
                ) : filteredContratos.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="py-20 text-center">
                      <div className="flex flex-col items-center justify-center text-slate-400">
                        <i className="ri-file-search-line text-5xl mb-4 opacity-50"></i>
                        <p className="font-semibold text-lg text-slate-600">No se encontraron contratos</p>
                        <p className="text-sm">Aún no hay contratos registrados o no coinciden con los filtros.</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredContratos.map(contrato => {
                    const diff = new Date(contrato.fechaFin).getTime() - new Date().getTime();
                    const daysToExpiry = Math.ceil(diff / (1000 * 3600 * 24));
                    const isExpiring = contrato.status === 'ACTIVO' && daysToExpiry <= 5 && daysToExpiry >= 0;

                    return (
                      <tr key={contrato.id} className={`border-b border-slate-100 hover:bg-slate-50 ${isExpiring ? 'bg-orange-50/50' : ''}`}>
                        <td className="py-3 px-4">
                          <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${
                            contrato.tipoContrato === 'INDIVIDUAL'
                              ? 'bg-blue-100 text-blue-700'
                              : 'bg-purple-100 text-purple-700'
                          }`}>
                            <i className={contrato.tipoContrato === 'INDIVIDUAL' ? 'ri-user-line' : 'ri-building-line'}></i>
                            {contrato.tipoContrato}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <div>
                            <p className="text-sm font-medium text-slate-800">{contrato.cliente}</p>
                            {contrato.empresa && (
                              <p className="text-xs text-slate-500 mt-0.5">{contrato.empresa}</p>
                            )}
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex flex-wrap gap-1">
                            {contrato.contractVehicles?.map((cv, idx) => (
                              <span key={idx} className="inline-flex items-center gap-1 px-2 py-1 bg-slate-100 text-slate-700 rounded-lg text-xs font-semibold">
                                {cv.vehiculo.placa}
                              </span>
                            ))}
                          </div>
                          <p className="text-xs text-slate-500 mt-1">{contrato.contractVehicles?.length || 0} vehículo{(contrato.contractVehicles?.length || 0) > 1 ? 's' : ''}</p>
                        </td>
                        <td className="py-3 px-4 text-sm text-slate-700">{contrato.plan}</td>
                        <td className="py-3 px-4 text-sm font-semibold text-slate-800">{formatCOP(contrato.valorMensual)}</td>
                        <td className="py-3 px-4 text-sm text-slate-700">
                          {new Date(contrato.fechaInicio).toLocaleDateString('es-CO')} - {new Date(contrato.fechaFin).toLocaleDateString('es-CO')}
                        </td>
                        <td className="py-3 px-4 text-sm">
                          <span className="inline-flex items-center gap-1 px-2 py-1 bg-teal-50 text-teal-700 rounded-lg font-bold border border-teal-100">
                            {(() => {
                              const s = new Date(contrato.fechaInicio);
                              const e = new Date(contrato.fechaFin);
                              const multiplier = contrato.plan === 'TRIMESTRAL' ? 3 : contrato.plan === 'SEMESTRAL' ? 6 : contrato.plan === 'ANUAL' ? 12 : 1;
                              const m = (e.getFullYear() - s.getFullYear()) * 12 + (e.getMonth() - s.getMonth());
                              const p = Math.ceil(m / multiplier);
                              return p <= 0 ? 1 : p;
                            })()} periodos
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${
                            contrato.status === 'ACTIVO' ? 'bg-green-100 text-green-700' :
                            contrato.status === 'VENCIDO' ? 'bg-orange-100 text-orange-700' :
                            'bg-red-100 text-red-700'
                          }`}>
                            {contrato.status}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          {contrato.renovacionAutomatica ? (
                            <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-medium">
                              <i className="ri-refresh-line"></i>
                              Automática
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-1 px-2 py-1 bg-slate-100 text-slate-600 rounded-lg text-xs font-medium">
                              Manual
                            </span>
                          )}
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex items-center gap-2">
                            {contrato.status !== 'CANCELADO' && (
                              <button
                                onClick={() => handleOpenPayment(contrato)}
                                className="w-8 h-8 flex items-center justify-center text-teal-600 hover:bg-teal-50 rounded-lg transition cursor-pointer"
                                title="Registrar Pago"
                              >
                                <i className="ri-hand-coin-line text-lg"></i>
                              </button>
                            )}
                            <button
                              onClick={() => handleEdit(contrato)}
                              className="w-8 h-8 flex items-center justify-center text-slate-600 hover:bg-slate-100 rounded-lg transition cursor-pointer"
                              title="Editar"
                            >
                              <i className="ri-edit-line"></i>
                            </button>
                            <button
                              onClick={() => handleDelete(contrato.id)}
                              className="w-8 h-8 flex items-center justify-center text-red-500 hover:bg-red-50 rounded-lg transition cursor-pointer"
                              title="Eliminar"
                            >
                              <i className="ri-delete-bin-line"></i>
                            </button>
                            <button
                              onClick={() => handleToggleStatus(contrato.id)}
                              className={`w-8 h-8 flex items-center justify-center rounded-lg transition cursor-pointer ${
                                contrato.status === 'ACTIVO'
                                  ? 'text-orange-500 hover:bg-orange-50'
                                  : 'text-green-500 hover:bg-green-50'
                              }`}
                              title={contrato.status === 'ACTIVO' ? 'Desactivar' : 'Activar'}
                            >
                              <i className={contrato.status === 'ACTIVO' ? 'ri-stop-circle-line' : 'ri-play-circle-line'}></i>
                            </button>
                            {(contrato.status === 'ACTIVO' || isExpiring) && (
                                <button
                                  onClick={() => handleSendReminder(contrato.id, contrato.email)}
                                  className="w-8 h-8 flex items-center justify-center text-blue-500 hover:bg-blue-50 rounded-lg transition cursor-pointer"
                                  title="Enviar Recordatorio"
                                >
                                  <i className="ri-mail-send-line"></i>
                                </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Cobrar Cuota */}
      {showPaymentModal && selectedContract && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
            <div className="bg-teal-500 px-6 py-4 flex items-center justify-between text-white">
              <div>
                <h2 className="text-xl font-bold">Registrar Pago</h2>
                <p className="text-teal-100 text-sm">{selectedContract.cliente}</p>
              </div>
              <button
                onClick={() => setShowPaymentModal(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-teal-600 rounded-lg transition cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <form onSubmit={handlePaymentSubmit} className="p-6">
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="flex items-center gap-2 text-sm font-medium text-slate-700 mb-2">
                       <i className="ri-calendar-event-line text-teal-600"></i>
                       Periodos a Pagar
                    </label>
                    <div className="flex items-center gap-1 bg-slate-50 p-1 rounded-2xl border border-slate-200">
                       <button
                         type="button"
                         onClick={() => {
                           const m = Math.max(1, (paymentData.meses || 1) - 1);
                           setPaymentData({
                             ...paymentData,
                             meses: m,
                             monto: (selectedContract?.valorMensual || 0) * (selectedContract?.plan === "TRIMESTRAL" ? 3 : selectedContract?.plan === "SEMESTRAL" ? 6 : selectedContract?.plan === "ANUAL" ? 12 : 1) * m
                           });
                         }}
                         className="w-11 h-11 flex items-center justify-center bg-teal-500 text-white rounded-xl hover:bg-teal-600 active:scale-95 transition-all shadow-sm border border-teal-200 cursor-pointer"
                       >
                         <i className="ri-subtract-line text-xl"></i>
                       </button>
                       <input
                         type="number"
                         value={paymentData.meses || ''}
                         onChange={(e) => {
                           const val = e.target.value.replace(/[^0-9]/g, '');
                           if (val === '') {
                             setPaymentData({ ...paymentData, meses: undefined, monto: 0 });
                             return;
                           }
                           const m = parseInt(val);
                           setPaymentData({
                             ...paymentData,
                             meses: m,
                             monto: (selectedContract?.valorMensual || 0) * (selectedContract?.plan === "TRIMESTRAL" ? 3 : selectedContract?.plan === "SEMESTRAL" ? 6 : selectedContract?.plan === "ANUAL" ? 12 : 1) * m
                           });
                         }}
                         onKeyDown={(e) => {
                           if (['-', '+', 'e', 'E', '.', ','].includes(e.key)) {
                             e.preventDefault();
                           }
                         }}
                         min="1"
                         className="flex-1 w-12 bg-transparent border-none focus:outline-none focus:ring-0 text-center font-bold text-lg text-slate-800 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                         required
                       />
                       <button
                         type="button"
                         onClick={() => {
                           const m = (paymentData.meses || 1) + 1;
                           setPaymentData({
                             ...paymentData,
                             meses: m,
                             monto: (selectedContract?.valorMensual || 0) * (selectedContract?.plan === "TRIMESTRAL" ? 3 : selectedContract?.plan === "SEMESTRAL" ? 6 : selectedContract?.plan === "ANUAL" ? 12 : 1) * m
                           });
                         }}
                         className="w-11 h-11 flex items-center justify-center bg-teal-500 text-white rounded-xl hover:bg-teal-600 active:scale-95 transition-all shadow-sm border border-teal-200 cursor-pointer"
                       >
                         <i className="ri-add-line text-xl"></i>
                       </button>
                    </div>
                  </div>
                  <div>
                    <label className="flex items-center gap-2 text-sm font-medium text-slate-700 mb-2">
                      <i className="ri-money-dollar-circle-line text-teal-600"></i>
                      Monto Total <span className="text-red-500">*</span>
                    </label>
                    <CurrencyInput
                      value={paymentData.monto}
                      onChange={(val) => setPaymentData({ ...paymentData, monto: val })}
                      className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-lg font-bold"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="flex items-center gap-2 text-sm font-medium text-slate-700 mb-2">
                    <i className="ri-bank-card-line text-teal-600"></i>
                    Método de Pago <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={paymentData.metodoPago}
                    onChange={(e) => setPaymentData({ ...paymentData, metodoPago: e.target.value as any })}
                    className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
                    required
                  >
                    <option value="EFECTIVO">Efectivo</option>
                    <option value="TARJETA">Tarjeta</option>
                    <option value="TRANSFERENCIA">Transferencia</option>
                    <option value="QR">Código QR</option>
                  </select>
                </div>

                <div>
                  <label className="flex items-center gap-2 text-sm font-medium text-slate-700 mb-2">
                    <i className="ri-sticky-note-line text-teal-600"></i>
                    Observaciones
                  </label>
                  <textarea
                    value={paymentData.observaciones}
                    onChange={(e) => setPaymentData({ ...paymentData, observaciones: e.target.value })}
                    rows={2}
                    className="w-full px-4 py-2 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm resize-none"
                    placeholder="Nota opcional sobre el pago..."
                  />
                </div>
              </div>

              <div className="flex gap-3 mt-8">
                <button
                  type="button"
                  onClick={() => setShowPaymentModal(false)}
                  className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl hover:bg-slate-200 transition font-medium cursor-pointer"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex-[2] py-3 bg-teal-600 text-white rounded-xl hover:bg-teal-700 transition font-bold disabled:opacity-50 flex items-center justify-center gap-2 cursor-pointer"
                >
                  {isSubmitting ? (
                    <i className="ri-loader-4-line animate-spin"></i>
                  ) : (
                    <i className="ri-check-line text-lg"></i>
                  )}
                  Confirmar Pago
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Reporte de Cobros */}
      {showReportModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
            <div className="bg-slate-800 px-6 py-4 flex items-center justify-between text-white">
              <div>
                <h2 className="text-xl font-bold font-['Outfit']">Reporte Diario de Contratos</h2>
                <p className="text-slate-400 text-sm">Recaudo total del día de hoy</p>
              </div>
              <button
                onClick={() => setShowReportModal(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-slate-700 rounded-lg transition cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 bg-slate-50">
              {reportLoading ? (
                <div className="flex flex-col items-center justify-center py-20">
                  <i className="ri-loader-4-line text-4xl animate-spin text-teal-600 mb-4"></i>
                  <p className="text-slate-500">Generando reporte...</p>
                </div>
              ) : dailyReport ? (
                <div className="space-y-6">
                  {/* Resumen por método */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {dailyReport.summary.map((item, idx) => (
                      <div key={idx} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
                        <p className="text-xs text-slate-500 uppercase font-bold tracking-wider mb-1">{item.metodo}</p>
                        <p className="text-xl font-bold text-slate-800">{formatCOP(item.total)}</p>
                        <p className="text-xs text-slate-400 mt-1">{item.count} transacciones</p>
                      </div>
                    ))}
                    <div className="bg-teal-600 p-4 rounded-xl shadow-lg sm:col-span-2 md:col-span-1 border border-teal-500">
                      <p className="text-xs text-teal-100 uppercase font-bold tracking-wider mb-1">TOTAL GENERAL</p>
                      <p className="text-2xl font-black text-white">{formatCOP(dailyReport.total)}</p>
                      <p className="text-xs text-teal-200 mt-1">Recaudo total hoy</p>
                    </div>
                  </div>

                  {/* Detalle de transacciones */}
                  <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
                    <div className="px-4 py-3 border-b border-slate-100 bg-slate-50">
                      <h3 className="font-bold text-slate-700 text-sm px-1 flex items-center gap-2">
                        <i className="ri-list-check-2 text-teal-600"></i>
                        Detalle de Transacciones
                      </h3>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-left">
                        <thead>
                          <tr className="bg-slate-50 text-slate-500 text-[11px] uppercase tracking-wider font-bold">
                            <th className="py-2 px-4">Hora</th>
                            <th className="py-2 px-4">Cliente</th>
                            <th className="py-2 px-4">Método</th>
                            <th className="py-2 px-4">Monto</th>
                            <th className="py-2 px-4">Operador</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                          {dailyReport.transactions.length === 0 ? (
                            <tr>
                              <td colSpan={5} className="py-10 text-center text-slate-400 text-sm">
                                No hay cobros registrados hoy
                              </td>
                            </tr>
                          ) : (
                            dailyReport.transactions.map((t, idx) => (
                              <tr key={idx} className="hover:bg-slate-50 text-sm">
                                <td className="py-2 px-4 text-slate-500 whitespace-nowrap">
                                  {new Date(t.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </td>
                                <td className="py-2 px-4">
                                  <p className="font-semibold text-slate-700">{t.contract.cliente}</p>
                                  <p className="text-[10px] text-slate-400">{t.contract.plan}</p>
                                </td>
                                <td className="py-2 px-4">
                                  <span className="bg-slate-100 text-slate-600 px-2 py-0.5 rounded text-[10px] font-bold">
                                    {t.metodoPago}
                                  </span>
                                </td>
                                <td className="py-2 px-4 font-bold text-slate-800">
                                  {formatCOP(t.total)}
                                </td>
                                <td className="py-2 px-4 text-slate-500 text-xs text-nowrap">
                                  {t.operador?.nombre || 'N/A'}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center py-20 text-slate-400">
                  Ocurrió un error al cargar los datos
                </div>
              )}
            </div>

            <div className="px-6 py-4 bg-white border-t border-slate-200 flex justify-end">
              <button
                onClick={() => setShowReportModal(false)}
                className="px-6 py-2.5 bg-slate-800 text-white rounded-xl hover:bg-slate-900 transition font-bold text-sm cursor-pointer"
              >
                Cerrar Reporte
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nuevo Contrato */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
              <div>
                <h2 className="text-xl font-bold text-slate-800">{editingId ? 'Editar Contrato' : 'Nuevo Contrato'}</h2>
                <p className="text-sm text-slate-500 mt-1">Complete la información del contrato</p>
              </div>
              <button
                onClick={() => setShowModal(false)}
                className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6">
              {/* Tipo de Contrato */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-slate-700 mb-3">
                  Tipo de Contrato <span className="text-red-500">*</span>
                </label>
                <div className="grid grid-cols-2 gap-4">
                  <label className="cursor-pointer">
                    <input
                      type="radio"
                      name="tipoContrato"
                      value="INDIVIDUAL"
                      checked={formData.tipoContrato === 'INDIVIDUAL'}
                      onChange={handleInputChange}
                      className="hidden"
                    />
                    <div className={`border-2 rounded-xl p-6 transition h-full ${
                      formData.tipoContrato === 'INDIVIDUAL'
                        ? 'border-teal-500 bg-teal-50'
                        : 'border-slate-200 hover:border-slate-300'
                    }`}>
                      <div className="flex flex-col items-center text-center gap-4">
                        <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${
                          formData.tipoContrato === 'INDIVIDUAL' ? 'bg-teal-500' : 'bg-slate-200'
                        }`}>
                          <i className={`ri-user-line text-3xl ${
                            formData.tipoContrato === 'INDIVIDUAL' ? 'text-white' : 'text-slate-600'
                          }`}></i>
                        </div>
                        <div>
                          <p className="text-lg font-bold text-slate-800 mb-1">Individual</p>
                          <p className="text-sm text-slate-500">Máximo 2 vehículos</p>
                        </div>
                      </div>
                    </div>
                  </label>
                  <label className="cursor-pointer">
                    <input
                      type="radio"
                      name="tipoContrato"
                      value="EMPRESARIAL"
                      checked={formData.tipoContrato === 'EMPRESARIAL'}
                      onChange={handleInputChange}
                      className="hidden"
                    />
                    <div className={`border-2 rounded-xl p-6 transition h-full ${
                      formData.tipoContrato === 'EMPRESARIAL'
                        ? 'border-purple-500 bg-purple-50'
                        : 'border-slate-200 hover:border-slate-300'
                    }`}>
                      <div className="flex flex-col items-center text-center gap-4">
                        <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${
                          formData.tipoContrato === 'EMPRESARIAL' ? 'bg-purple-500' : 'bg-slate-200'
                        }`}>
                          <i className={`ri-building-line text-3xl ${
                            formData.tipoContrato === 'EMPRESARIAL' ? 'text-white' : 'text-slate-600'
                          }`}></i>
                        </div>
                        <div>
                          <p className="text-lg font-bold text-slate-800 mb-1">Empresarial</p>
                          <p className="text-sm text-slate-500">Múltiples vehículos</p>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              {/* Información del Cliente/Empresa */}
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-slate-800 mb-4 flex items-center gap-2">
                  <i className={`${formData.tipoContrato === 'EMPRESARIAL' ? 'ri-building-line' : 'ri-user-line'} text-teal-600`}></i>
                  {formData.tipoContrato === 'EMPRESARIAL' ? 'Información de la Empresa' : 'Información del Cliente'}
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  {formData.tipoContrato === 'EMPRESARIAL' && (
                    <>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          Nombre de la Empresa <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="empresa"
                          value={formData.empresa}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                          placeholder="Ej: Tech Solutions S.A.S"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          NIT <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="nit"
                          value={formData.nit}
                          onChange={handleInputChange}
                          required
                          maxLength={15}
                          className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                          placeholder="Ej: 900123456-7"
                        />
                      </div>
                    </>
                  )}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      {formData.tipoContrato === 'EMPRESARIAL' ? 'Representante Legal' : 'Nombre Completo'} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="cliente"
                      value={formData.cliente}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                      placeholder="Ej: Juan Pérez"
                    />
                  </div>
                  {formData.tipoContrato === 'INDIVIDUAL' && (
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-2">
                        Documento <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="documento"
                        value={formData.documento}
                        onChange={handleInputChange}
                        required
                        maxLength={13}
                        className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                        placeholder="Ej: 1234567890"
                      />
                    </div>
                  )}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Teléfono <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleInputChange}
                      required
                      maxLength={13}
                      className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                      placeholder="Ej: 3001234567"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                      placeholder="Ej: cliente@email.com"
                    />
                  </div>
                  {formData.tipoContrato === 'EMPRESARIAL' && (
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-slate-700 mb-2">
                        Dirección
                      </label>
                      <input
                        type="text"
                        name="direccion"
                        value={formData.direccion}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                        placeholder="Ej: Calle 123 #45-67"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Vehículos */}
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-slate-800 mb-4 flex items-center gap-2">
                  <i className="ri-car-line text-teal-600"></i>
                  Vehículos {formData.tipoContrato === 'EMPRESARIAL' && '(Puede agregar múltiples)'}
                </h3>

                {/* Lista de vehículos agregados */}
                {vehiculos.length > 0 && (
                  <div className="mb-4 space-y-2">
                    {vehiculos.map((v, idx) => (
                      <div key={idx} className="flex items-center justify-between bg-slate-50 p-3 rounded-xl">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                            <i className="ri-car-line text-teal-600"></i>
                          </div>
                          <div>
                            <p className="font-semibold text-slate-800">{v.placa}</p>
                            <p className="text-xs text-slate-500">{v.tipo} - {v.marca} {v.modelo} {v.color && `(${v.color})`}</p>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => eliminarVehiculo(idx)}
                          className="w-8 h-8 flex items-center justify-center text-red-600 hover:bg-red-50 rounded-lg transition cursor-pointer"
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {/* Formulario para agregar vehículo */}
                {(formData.tipoContrato === 'EMPRESARIAL' || (formData.tipoContrato === 'INDIVIDUAL' && vehiculos.length < 2)) && (
                  <div className="border-2 border-dashed border-slate-300 rounded-xl p-4">
                    <div className="grid grid-cols-3 gap-4 mb-3">
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          Placa <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="placa"
                          value={vehiculoTemp.placa}
                          onChange={handleVehiculoChange}
                          className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm uppercase"
                          placeholder="Ej: ABC123"
                          maxLength={7}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          Tipo <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="tipo"
                          value={vehiculoTemp.tipo}
                          onChange={handleVehiculoChange}
                          className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm cursor-pointer"
                        >
                          <option value="AUTO">Auto</option>
                          <option value="MOTO">Moto</option>
                          <option value="CAMIONETA">Camioneta</option>
                          <option value="CAMION">Camión</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          Marca <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="marca"
                          maxLength={15}
                          value={vehiculoTemp.marca}
                          onChange={handleVehiculoChange}
                          className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                          placeholder="Ej: Toyota"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          Línea
                        </label>
                        <input
                          type="text"
                          name="modelo"
                          maxLength={15}
                          value={vehiculoTemp.modelo}
                          onChange={handleVehiculoChange}
                          className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                          placeholder="Ej: Corolla"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          Color
                        </label>
                        <input
                          type="text"
                          name="color"
                          maxLength={15}
                          value={vehiculoTemp.color}
                          onChange={handleVehiculoChange}
                          className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                          placeholder="Ej: Blanco"
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={agregarVehiculo}
                      className="w-full py-2.5 bg-teal-500 hover:bg-teal-600 text-white rounded-xl transition flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-add-line text-lg"></i>
                      Agregar Vehículo
                    </button>
                  </div>
                )}
              </div>

              {/* Detalles del Contrato */}
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-slate-800 mb-4 flex items-center gap-2">
                  <i className="ri-file-text-line text-teal-600"></i>
                  Detalles del Contrato
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Tipo de Plan <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="plan"
                      value={formData.plan}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm cursor-pointer"
                    >
                      <option value="MENSUAL">Mensual</option>
                      <option value="TRIMESTRAL">Trimestral</option>
                      <option value="SEMESTRAL">Semestral</option>
                      <option value="ANUAL">Anual</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Valor Mensual <span className="text-red-500">*</span>
                    </label>
                    <CurrencyInput
                      name="valorMensual"
                      value={formData.valorMensual}
                      onChange={(value) => setFormData({ ...formData, valorMensual: value })}
                      required
                      className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm"
                      placeholder="Ej: 250.000"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Fecha de Inicio <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="fechaInicio"
                      value={formData.fechaInicio}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm cursor-pointer"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        name="renovacionAutomatica"
                        checked={formData.renovacionAutomatica}
                        onChange={handleInputChange}
                        className="w-5 h-5 text-teal-500 border-slate-300 rounded focus:ring-teal-500 cursor-pointer"
                      />
                      <span className="text-sm font-medium text-slate-700">
                        Renovación Automática
                      </span>
                    </label>
                    <p className="text-xs text-slate-500 ml-7 mt-1">
                      El contrato se renovará automáticamente al finalizar el período
                    </p>
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-slate-700 mb-2">
                      Observaciones
                    </label>
                    <textarea
                      name="observaciones"
                      value={formData.observaciones}
                      onChange={handleInputChange}
                      rows={3}
                      className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm resize-none"
                      placeholder="Notas adicionales sobre el contrato..."
                    ></textarea>
                  </div>
                </div>
              </div>

              {/* Botones */}
              <div className="flex justify-end gap-3 pt-4 border-t border-slate-200">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  disabled={isSubmitting}
                  className="px-6 py-2.5 bg-slate-100 text-slate-700 rounded-xl hover:bg-slate-200 transition font-medium disabled:opacity-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-6 py-2.5 bg-teal-600 text-white rounded-xl hover:bg-teal-700 transition font-bold disabled:opacity-50 flex items-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      Guardando...
                    </>
                  ) : 'Crear Contrato'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>

  );
}
